module.exports = __webpack_public_path__ + "media/images/sosial_media/fb-full-c-655bc61f53c3cc4e1b396fe5b2e2b67a.png";